<template>
    <div v-if="Object.keys(packageItems).length != 0">
        <div class="card">
            <div class="card-body p-5">
                <h4>{{$t('header.summary')}}</h4>
                <div class="summary">
                    <table class="table table-striped">
                        <thead class="thead-themed">
                            <tr>
                                <th v-for="tblHeader in fields" :key="tblHeader.key" :style="[tblHeader.key == 'item' ? {'width': '80%'} : '']">{{tblHeader.label}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr><td>{{$t('label.credit')}}</td><td>{{formatPrice(packageItems.package.credits)}}</td></tr>
                            <tr><td>{{$t('label.point')}}</td><td>{{packageItems.package.points}}</td></tr>
                            <tr v-if="packageItems.package.items !=0" class="fw-500 text-primary">{{$t('subMenu.salon_menu_service') + '/' + $t('subMenu.salon_menu_product')}}<td></td></tr>
                            <tr v-for="item in packageItems.package.items" :key="item.itemID">
                                <td>{{item.quantity}}x {{item.itemTitle}}</td>
                                <td>{{calculateItemPrice(item.unitPrice, item.quantity)}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <form>
                    <div class="form-group row border-bottom pb-5 mb-5">
                        <div class="col-md-8 col-sm-12 d-flex align-items-center">
                            <label class="form-label text-muted w-100 text-right">{{$t('label.package_value')}}</label>
                        </div>
                        <div class="input-group col-md-4 col-sm-12">
                            <div class="input-group-prepend">
                                <span class="input-group-text bg-transparent border-right-0">
                                    <i class="fas fa-hand-holding-usd"></i>
                                </span>
                            </div>
                            <input type="text" class="form-control" :placeholder="$t('label.package_value')" v-model="packageValue" disabled="">
                        </div>
                    </div>
                    <div class="row mt-3 mb-4">
                        <div class="col-md-6 col-sm-12">
                            <div class="form-group">
                                <label class="form-label">{{$t('label.price')}}</label>
                                <div class="input-group bg-white shadow-inset-2">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text bg-transparent border-right-0">
                                            <i class="fas fa-dollar-sign"></i>
                                        </span>
                                    </div>
                                    <input class="form-control service_row_num" type="number" step="any"
                                        :min="0" 
                                        v-model="price" 
                                        @keypress="isNumber($event)"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-12">
                            <div class="form-group">
                                <label class="form-label">{{$t('label.base_price')}}</label>
                                <div class="input-group bg-white shadow-inset-2">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text bg-transparent border-right-0">
                                            <i class="fas fa-dollar-sign"></i>
                                        </span>
                                    </div>
                                    <input class="form-control service_row_num" type="number" step="any"
                                        :min="0" 
                                        v-model="basePrice" 
                                        @keypress="isNumber($event)"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-6">
                            <button type="button" class="btn border-0 btn-secondary btn-padding waves-effect waves-themed mr-3 mb-2" @click="returnPackageList">{{$t('button_link.cancel')}}</button>
                            <button type="button" class="btn border-0 btn-dark btn-padding waves-effect waves-themed mr-3 mb-2" @click="returnPreviousStep">{{$t('button_link.prev')}}</button>
                            <button type="button" class="btn border-0 btn-primary btn-padding waves-effect waves-themed mb-2" @click="showSubmitModal">{{$t('button_link.done')}}</button>
                        </div>
                        <div class="d-none col-6 text-right">
                            <button v-if="isEdit" type="button" class="btn border-0 btn-danger btn-padding waves-effect waves-themed" @click="disablePackage">Disable</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <modal ref="modal" @performConfirmAction="submitPackage"></modal>
        <!-- <div :class="{'show': submitPackageToggle }" class="modal fade">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header border-bottom">
                        <h5 class="modal-title text-capitalize h4">{{modalMsg}} Package</h5>
                        <button type="button" class="close" @click="submitPackageToggle = !submitPackageToggle">
                            <span aria-hidden="true"><i class="fal fa-times"></i></span>
                        </button>
                    </div>
                    <div class="modal-body pb-0">
                        <p>Are you sure you want to {{modalMsg}} "{{packageItems.title}}"?</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary waves-effect waves-themed" @click="submitPackageToggle = !submitPackageToggle">No</button>
                        <button type="button" class="btn btn-primary waves-effect waves-themed" @click="submitPackage">Yes</button>
                    </div>
                </div>
            </div>
        </div> -->
    </div>
</template>

<script>
import Modal from './../../Delete_Modal'
import {formatPrice, isNumber, calculateTotal} from './../../../../assets/js/dashboard/utilities'

export default {
    name: 'packagePrice',
    props:{
        package: { type: Object },
        isEdit: { type: Boolean }
    },
    components: {
        Modal
    },
    data(){
        let mTitle = this.isEdit ? "edit" : "add";
        let itm = {};
        if(this.package != undefined){
            itm = this.package;
        }
        return{
            step: 3, submitPackageToggle: false,
            modalMsg: mTitle,
            packageItems: itm,
            price: 0, basePrice: 0,
            result: {}
        }
    },
    computed:{
        packageValue(){
            var total = 0;
            var arr = this.packageItems.package.items;
            for(var i=0; i<arr.length; i++){
                total += calculateTotal(arr[i].unitPrice, arr[i].quantity)
            }
            total += parseFloat(this.packageItems.package.credits);
            return formatPrice(total);
        }, 
        fields(){
            return[
                { key: 'item', label: this.$i18n.t('table.header.item'), thClass: 'thead-themed align-middle'},
                { key: 'unit_price', label: this.$i18n.t('table.header.unit_price'), thClass: 'thead-themed align-middle'}
            ]
        },
    },
    methods:{
        isNumber(e){
            return isNumber(e);
        },
        formatPrice(price){
            return formatPrice(price);
        },
        returnPreviousStep(){
            this.$emit('returnPreviousStep', this.step);
        },
        returnPackageList(){
            this.$emit('returnPackageList');
        },
        calculateItemPrice(price, quantity){
            var total = calculateTotal(price, quantity);
            return formatPrice(total);
        },
        showSubmitModal(){
            var action = this.isEdit ? this.$i18n.t('header.edit') : this.$i18n.t('header.add')
            var title = action + this.$i18n.t('subMenu.salon_menu_package')
            var message = this.$i18n.t('message.confirmation.question', 
                {
                    'action': action.toLowerCase(),
                    'item': this.packageItems.title
                }
            )
            this.$refs.modal.showModal(title, message)
        },
        submitPackage(){
            this.result["price"] = this.price;
            this.result["basePrice"] = this.basePrice;
            
            this.$emit('submitPackage', this.result);
            this.$refs.toggleModal = false
        },
        disablePackage(){
            this.result["isEnable"] = 0;
            this.submitPackage();
        },
    },
    mounted(){
        let $vm = this;
        if($vm.isEdit){
            if(Object.keys($vm.packageItems).length != 0){
                $vm.price = $vm.packageItems.price;
                $vm.basePrice = $vm.packageItems.basePrice;
            }
        }
    }
}
</script>

<style scoped>
.summary{
    max-height: 65vh;
    overflow-y: auto;
}

.show{
    display: block;
}
</style>